<template>
  <div class="component-form-wizard-step-header">
    <h3 class="fs40">
      {{ title }}
      <span
        v-if="optional"
        class="component-form-wizard-step-header__title__optional"
        >(optional)</span
      >
    </h3>
    <p
      v-if="description"
      class="component-form-wizard-step-header__description"
      v-html="description"
    ></p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormWizardStepHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    description: String,
    optional: Boolean
  }
}
</script>

<style lang="scss" scoped>
.component-form-wizard-step-header {
  margin-bottom: 2.5rem;

  &__title {
    &__optional {
      color: $gray-400;
    }
  }

  &__description {
    margin-top: 0.3rem;
    color: $gray-700;
    max-width: 560px;
    line-height: 1.6;
  }
}
</style>
